module.exports = "../assets/video-icon.fde6ee61.svg";